<template>
  <div class="artworks-tab">
    <ArtworksFiltersPanel />
    <div class="employee__filtration upper-pagination-wrapper flex-column flex-sm-row m-0">
      <CatalogNumbersSearch />
      <Pagination v-if="anyResults" :meta="meta" />
    </div>
    <ArtworksList v-if="anyResults" />
    <div v-if="anyResults" class="col-12 employee__filtration p-0 my-3 mt-md-0 mb-md-5">
      <Pagination class="text-right" scrollPageToUp :meta="meta" />
    </div>
    <div v-if="tooManyResultsValue" class="filters__no-results text-center border-0">
      <span class="icon icon-no_results"></span>
      <p>{{ I18n.t("search_page.errors.too_many_results") }}</p>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Pagination from '@/shared/components/pagination/index';
  import ArtworksFiltersPanel from './filters/artworks_filters_panel';
  import ArtworksList from './artworks_list';
  import CatalogNumbersSearch from './catalog_numbers_search';

  export default {
    name: 'ArtworksTab',
    components: {
      ArtworksFiltersPanel,
      ArtworksList,
      Pagination,
      CatalogNumbersSearch,
    },
    computed: {
      ...mapGetters(['totalArtworksCount', 'tooManyResultsValue', 'meta', 'currentPage']),
      anyResults() {
        return this.totalArtworksCount > 0 || this.totalArtworksCount === '';
      },
      noResults() {
        return Object.keys(this.$route.query).length !== 0 &&
          this.totalArtworksCount === 0;
      },
      urlPage() {
        return this.$route.query.page || 1;
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenPageIsChanging']),
    },
    watch: {
      urlPage() {
        if (this.urlPage !== this.currentPage) {
          this.getArtworksWhenPageIsChanging({ currentPage: this.urlPage });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/artworks_tab.vue?0667b8f3